<template>
  <div
    class="fixed left-0 top-80px w-full bg-white shadow-lg border-t border-gray-100 z-50 animate-fade-in-down"
  >
    <div class="landing-container py-32px flex justify-start">
      <div class="grid grid-cols-2 gap-24px">
        <NuxtLink
          v-for="(item, idx) in productItems"
          :key="idx"
          :to="item.link"
          target="_blank"
          rel="noopener noreferrer"
          class="product-card group/item"
          @click="$emit('close')"
        >
          <i :class="[item.icon, 'product-icon']" aria-hidden="true"></i>
          <div class="flex flex-col justify-center py-14px">
            <div
              class="font-s-16px color-#000000 pf-sc-semibold group-hover/item:text-primary transition-colors"
            >
              {{ item.title }}
            </div>
            <div class="font-s-14px pf-sc-regular text-#64748b lh-22px mb-12px">
              {{ item.desc }}
            </div>
            <div class="flex items-center text-14px text-primary">
              查看详情
              <i
                class="i-custom-arrow-right-c ml-4px wh-18px color-primary group-hover/item:translate-x-5px transition-all duration-300"
                aria-hidden="true"
              ></i>
            </div>
          </div>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { productItems } from '~/constants/navigation'

  defineEmits(['close'])
</script>

<style scoped lang="scss">
  .product-card {
    @apply flex gap-16px p-8px w-358px rounded-8px bg-#f6f8fd cursor-pointer transition-all duration-300 border border-transparent;
    @apply hover:border-gray-100 hover:shadow-sm;
  }

  .product-icon {
    @apply wh-106px flex-shrink-0;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-fade-in-down {
    animation: fadeInDown 0.2s ease-out forwards;
    &::before {
      content: '';
      @apply absolute -top-10px left-0 w-full h-10px;
    }
  }
</style>
